export default __webpack_public_path__ + "static/team-pulse-4b68d1d819f272dd0d6ff49eccccb7c4.jpg";